var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _line, _line2, _line3, _path26, _path27, _line4, _line5, _line6, _line7, _line8, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _line9, _line10, _line11, _path54, _path55, _line12, _line13, _line14, _line15, _line16, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _line17, _line18, _line19, _path82, _path83, _path84, _line20, _line21, _line22, _line23, _line24, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackedCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 51,
    viewBox: "0 0 58 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9441 32.8359L48.3672 33.3128V34.3011L49.4479 35.4308L52.4241 35.954L55.5531 35.5637L57.001 34.4888V33.5005L52.9441 32.8359Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9441 32.834L48.3672 33.3109V34.2992L49.4479 35.4289L52.4241 35.952L55.5531 35.5617L57.001 34.4869V33.4986L52.9441 32.834Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9441 31.8477L49.8155 32.238L48.3672 33.3128L49.4479 34.4426L52.4241 34.9657L55.5531 34.5754L57.001 33.5005L55.9207 32.3708L52.9441 31.8477Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9441 31.8477L49.8155 32.238L48.3672 33.3128L49.4479 34.4426L52.4241 34.9657L55.5531 34.5754L57.001 33.5005L55.9207 32.3708L52.9441 31.8477Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0314 6.04102V37.8186L51.6653 40.9327L45.1017 42.7548L37.1861 42.2172L32.5547 39.6352V7.85768L37.1861 10.4397L45.1017 10.9769L51.6653 9.15513L53.0314 6.04102Z",
    fill: "#F1F2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1016 10.9764V12.7104V42.754L51.6648 40.9322V9.1543L45.1016 10.9764Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 9.59205L37.1861 12.174L45.1017 12.7117L51.6649 10.8895L53.0314 7.77539",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 11.3245L37.1861 13.9064L45.1017 14.4441L51.6649 12.6219L53.0314 9.50781",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 13.0589L37.1861 15.6408L45.1017 16.1785L51.6649 14.3563L53.0314 11.2422",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 14.7932L37.1861 17.3752L45.1017 17.9128L51.6649 16.0907L53.0314 12.9766",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 16.5276L37.1861 19.1096L45.1017 19.6472L51.6649 17.8251L53.0314 14.7109",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 18.262L37.1861 20.8439L45.1017 21.3816L51.6649 19.5594L53.0314 16.4453",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 19.9964L37.1861 22.5783L45.1017 23.116L51.6649 21.2938L53.0314 18.1797",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 21.7288L37.1861 24.3107L45.1017 24.8484L51.6649 23.0262L53.0314 19.9121",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 23.4631L37.1861 26.0451L45.1017 26.5827L51.6649 24.7606L53.0314 21.6465",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 25.1975L37.1861 27.7795L45.1017 28.3171L51.6649 26.495L53.0314 23.3809",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 26.9299L37.1861 29.5119L45.1017 30.0495L51.6649 28.2274L53.0314 25.1133",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 28.6643L37.1861 31.2463L45.1017 31.7839L51.6649 29.9618L53.0314 26.8477",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 30.3987L37.1861 32.9807L45.1017 33.5183L51.6649 31.6961L53.0314 28.582",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 32.1331L37.1861 34.715L45.1017 35.2527L51.6649 33.4305L53.0314 30.3164",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 33.8674L37.1861 36.4494L45.1017 36.987L51.6649 35.1649L53.0314 32.0508",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 35.6018L37.1861 38.1838L45.1017 38.7214L51.6649 36.8993L53.0314 33.7852",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 37.3342L37.1861 39.9162L45.1017 40.4538L51.6649 38.6317L53.0314 35.5176",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5547 39.0686L37.1861 41.6506L45.1017 42.1882L51.6649 40.3661L53.0314 37.252",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0314 6.04102V37.8186L51.6653 40.9327L45.1017 42.7548L37.1861 42.2172L32.5547 39.6352V7.85768L37.1861 10.4397L45.1017 10.9769L51.6653 9.15513L53.0314 6.04102Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 37.3834,
    y1: 12.3698,
    x2: 37.3834,
    y2: 31.0513,
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 45.2975,
    y1: 11.1725,
    x2: 45.2975,
    y2: 39.2516,
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 51.86,
    y1: 11.0846,
    x2: 51.86,
    y2: 30.3034,
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4 3.45951L40.4844 2.92188L33.9207 4.74403L32.5547 7.85814L37.1861 10.4401L45.1017 10.9777L51.6649 9.15559L53.0314 6.04148L48.4 3.45951Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M47.316 3.45058L40.9369 3.01758L35.648 4.48588L34.5469 6.99535L38.279 9.07613L44.658 9.50914L49.9474 8.04084L51.0481 5.53136L47.316 3.45058Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 32.7582,
    y1: 7.34196,
    x2: 34.0267,
    y2: 6.79146,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 37.1257,
    y1: 9.88873,
    x2: 37.7254,
    y2: 9.13756,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 45.1455,
    y1: 9.77012,
    x2: 45.3649,
    y2: 10.4889,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 51.1222,
    y1: 9.27235,
    x2: 50.0579,
    y2: 8.58368,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 52.546,
    y1: 6.30873,
    x2: 51.0716,
    y2: 5.8828,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0352 4.53123L39.7507 3.53747L45.794 3.29883L45.158 4.79221H41.7386L44.6011 6.1214L43.9616 7.43531L39.0352 4.53123Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0352 4.53125V5.56576L43.9616 8.62619V7.43533L39.0352 4.53125Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9609 8.62587L44.5609 7.19479L44.6005 6.12109L43.9609 7.435V8.62587Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7922 3.29883V4.53123L45.1562 5.92273V4.79221L45.7922 3.29883Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1612 5.92348L43.6063 5.65859L41.7422 4.79297H45.1612V5.92348Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1864 8.76367V31.6648L22.2016 33.909L17.4719 35.2221L11.7672 34.8345L8.42969 32.974V10.0729L11.7672 11.9334L17.4719 12.321L22.2016 11.0079L23.1864 8.76367Z",
    fill: "#F1F2FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4766 12.3209V13.5706V35.222L22.2067 33.9089V11.0078L17.4766 12.3209Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 11.3209L11.7672 13.1819L17.4719 13.569L22.202 12.2559L23.1864 10.0117",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 12.5709L11.7672 14.4319L17.4719 14.819L22.202 13.5059L23.1864 11.2617",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 13.8209L11.7672 15.6819L17.4719 16.069L22.202 14.7559L23.1864 12.5117",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 15.0709L11.7672 16.9319L17.4719 17.319L22.202 16.0059L23.1864 13.7617",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 16.3209L11.7672 18.1819L17.4719 18.569L22.202 17.2559L23.1864 15.0117",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 17.5709L11.7672 19.4319L17.4719 19.819L22.202 18.5059L23.1864 16.2617",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 18.819L11.7672 20.6799L17.4719 21.0671L22.202 19.7539L23.1864 17.5098",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 20.069L11.7672 21.9299L17.4719 22.3171L22.202 21.0039L23.1864 18.7598",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 21.319L11.7672 23.1799L17.4719 23.5671L22.202 22.2539L23.1864 20.0098",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 22.569L11.7672 24.4299L17.4719 24.8171L22.202 23.5039L23.1864 21.2598",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 23.817L11.7672 25.678L17.4719 26.0651L22.202 24.752L23.1864 22.5078",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 25.067L11.7672 26.928L17.4719 27.3151L22.202 26.002L23.1864 23.7578",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 26.317L11.7672 28.178L17.4719 28.5651L22.202 27.252L23.1864 25.0078",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 27.567L11.7672 29.428L17.4719 29.8151L22.202 28.502L23.1864 26.2578",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 28.817L11.7672 30.678L17.4719 31.0651L22.202 29.752L23.1864 27.5078",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 30.067L11.7672 31.928L17.4719 32.3151L22.202 31.002L23.1864 28.7578",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 31.3151L11.7672 33.176L17.4719 33.5632L22.202 32.25L23.1864 30.0059",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 32.5651L11.7672 34.426L17.4719 34.8132L22.202 33.5L23.1864 31.2559",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1864 8.76367V31.6648L22.2016 33.909L17.4719 35.2221L11.7672 34.8345L8.42969 32.974V10.0729L11.7672 11.9334L17.4719 12.321L22.2016 11.0079L23.1864 8.76367Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 11.9655,
    y1: 13.3795,
    x2: 11.9655,
    y2: 26.7333,
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 17.6725,
    y1: 12.5162,
    x2: 17.6725,
    y2: 32.6426,
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 22.3991,
    y1: 12.4537,
    x2: 22.3991,
    y2: 26.1947,
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8489 6.90278L14.1442 6.51562L9.41443 7.82836L8.42969 10.0725L11.7672 11.9335L17.4719 12.3206L22.202 11.0079L23.1864 8.76373L19.8489 6.90278Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0696 6.8963L14.4723 6.58398L10.6607 7.6424L9.86719 9.45084L12.5569 10.9505L17.1542 11.2624L20.9659 10.2044L21.7594 8.39595L19.0696 6.8963Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 8.63318,
    y1: 9.5568,
    x2: 9.34647,
    y2: 9.24729,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 11.7077,
    y1: 11.3829,
    x2: 12.0033,
    y2: 11.0126,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 17.6415,
    y1: 11.5221,
    x2: 17.7356,
    y2: 11.8306,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 21.6612,
    y1: 11.1239,
    x2: 21.0778,
    y2: 10.7464,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 22.7022,
    y1: 9.0313,
    x2: 21.8501,
    y2: 8.78498,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1016 7.67546L13.6173 6.95914L17.9724 6.78711L17.5139 7.86355H15.0499L17.1126 8.82165L16.6518 9.76838L13.1016 7.67546Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1016 7.67578V8.42149L16.6518 10.6269V9.76871L13.1016 7.67578Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6562 10.6252L17.0885 9.59384L17.1171 8.82031L16.6562 9.76705V10.6252Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9741 6.78711V7.67546L17.5156 8.67823V7.86355L17.9741 6.78711Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5148 8.67796L16.3941 8.48712L15.0508 7.86328H17.5148V8.67796Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2983 4.84375V43.9949L38.6152 47.8316L30.5288 50.0762L20.7762 49.4144L15.0703 46.2332V7.08167L20.7762 10.2628L30.5288 10.925L38.6152 8.68046L40.2983 4.84375Z",
    fill: "#F1F2FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5273 10.9243V13.0607V50.0754L38.6138 47.8309V8.67969L30.5273 10.9243Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 9.21838L20.7762 12.3995L30.5288 13.0618L38.6149 10.8172L40.2983 6.98047",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 11.3551L20.7762 14.5362L30.5288 15.1985L38.6149 12.9539L40.2983 9.11719",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 13.4899L20.7762 16.671L30.5288 17.3332L38.6149 15.0887L40.2983 11.252",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 15.6266L20.7762 18.8077L30.5288 19.47L38.6149 17.2254L40.2983 13.3887",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 17.7633L20.7762 20.9444L30.5288 21.6067L38.6149 19.3621L40.2983 15.5254",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 19.8981L20.7762 23.0792L30.5288 23.7414L38.6149 21.4969L40.2983 17.6602",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 22.0348L20.7762 25.2159L30.5288 25.8782L38.6149 23.6336L40.2983 19.7969",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 24.1715L20.7762 27.3526L30.5288 28.0149L38.6149 25.7703L40.2983 21.9336",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 26.3082L20.7762 29.4894L30.5288 30.1516L38.6149 27.907L40.2983 24.0703",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 28.4449L20.7762 31.6261L30.5288 32.2883L38.6149 30.0437L40.2983 26.207",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 30.5817L20.7762 33.7628L30.5288 34.425L38.6149 32.1805L40.2983 28.3438",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 32.7164L20.7762 35.8976L30.5288 36.5598L38.6149 34.3152L40.2983 30.4785",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 34.8531L20.7762 38.0343L30.5288 38.6965L38.6149 36.4519L40.2983 32.6152",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 36.9899L20.7762 40.171L30.5288 40.8332L38.6149 38.5887L40.2983 34.752",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 39.1246L20.7762 42.3058L30.5288 42.968L38.6149 40.7234L40.2983 36.8867",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 41.2614L20.7762 44.4425L30.5288 45.1047L38.6149 42.8601L40.2983 39.0234",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 43.3981L20.7762 46.5792L30.5288 47.2414L38.6149 44.9969L40.2983 41.1602",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 45.5348L20.7762 48.7159L30.5288 49.3782L38.6149 47.1336L40.2983 43.2969",
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2944 4.84375V43.9949L38.6113 47.8316L30.5249 50.0762L20.7723 49.4144L15.0664 46.2332V7.08167L20.7723 10.2628L30.5249 10.925L38.6113 8.68046L40.2944 4.84375Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 20.9694,
    y1: 12.5944,
    x2: 20.9694,
    y2: 35.7016,
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 30.7233,
    y1: 11.1217,
    x2: 30.7233,
    y2: 45.8069,
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 38.8092,
    y1: 11.0123,
    x2: 38.8092,
    y2: 34.7818,
    stroke: "#D7DBF4",
    strokeWidth: 0.39186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5924 1.66224L24.8398 1L16.7537 3.24497L15.0703 7.08128L20.7762 10.2628L30.5288 10.9246L38.6152 8.68007L40.2983 4.84337L34.5924 1.66224Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5885 1.66224L24.8359 1L16.7498 3.24497L15.0664 7.08128L20.7723 10.2628L30.5249 10.9246L38.6113 8.68007L40.2944 4.84337L34.5885 1.66224Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2476 1.6509L25.3885 1.11719L18.8722 2.92641L17.5156 6.01819L22.1137 8.58174L29.9729 9.11506L36.4895 7.30623L37.8457 4.21445L33.2476 1.6509Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 15.2738,
    y1: 6.56656,
    x2: 17.0036,
    y2: 5.81584,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 20.7116,
    y1: 9.71101,
    x2: 21.5637,
    y2: 8.64328,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 30.4658,
    y1: 9.37758,
    x2: 30.7891,
    y2: 10.4368,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 38.0714,
    y1: 8.79579,
    x2: 36.6075,
    y2: 7.84848,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 39.8117,
    y1: 5.11147,
    x2: 37.8204,
    y2: 4.53624,
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0547 2.9833L23.9364 1.75874L31.3817 1.46484L30.598 3.30502H26.3855L29.9122 4.94261L29.1242 6.56138L23.0547 2.9833Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0547 2.98438V4.2591L29.1242 8.02958V6.56245L23.0547 2.98438Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M29.125 8.02926L29.864 6.26589L29.913 4.94336L29.125 6.56214V8.02926Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3814 1.46484V2.9833L30.5977 4.69769V3.30502L31.3814 1.46484Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5953 4.69736L28.6795 4.37094L26.3828 3.30469H30.5953V4.69736Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42688 40.3398L1 40.9049V42.077L2.28138 43.4167L5.81048 44.0367L9.52022 43.5739L11.2374 42.2995V41.1275L6.42688 40.3398Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42688 40.3398L1 40.9049V42.077L2.28138 43.4167L5.81048 44.0367L9.52022 43.5739L11.2374 42.2995V41.1275L6.42688 40.3398Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42688 39.168L2.71713 39.6308L1 40.9051L2.28138 42.2449L5.81048 42.8648L9.52022 42.402L11.2374 41.1277L9.95597 39.7879L6.42688 39.168Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42688 39.168L2.71713 39.6308L1 40.9051L2.28138 42.2449L5.81048 42.8648L9.52022 42.402L11.2374 41.1277L9.95597 39.7879L6.42688 39.168Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1886 46.0134L40.0332 43.623L36.8086 45.8382V47.0201L38.8267 49.51L42.5721 50.5927L45.4593 49.6338L46.1886 47.1952V46.0134Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1925 46.0134L40.0371 43.623L36.8125 45.8382V47.0201L38.8306 49.51L42.576 50.5927L45.4632 49.6338L46.1925 47.1952V46.0134Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7786 43.5241L40.0332 42.4414L37.146 43.4003L36.8086 45.8388L39.2181 48.3287L42.9635 49.411L45.8508 48.4525L46.1886 46.014L43.7786 43.5241Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7786 43.5241L40.0332 42.4414L37.146 43.4003L36.8086 45.8388L39.2181 48.3287L42.9635 49.411L45.8508 48.4525L46.1886 46.014L43.7786 43.5241Z",
    stroke: "#1B4458",
    strokeWidth: 0.783721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedCoin);
export default __webpack_public_path__ + "static/media/stacked_coin.5e9b6410374f9b9f62cd27d8c2d812ae.svg";
export { ForwardRef as ReactComponent };